import React from "react";

const Checkbox = ({
  field,
  handleFieldChanged,
  type,
  value,
  showSimplifiedOptions,
}) => {
  return (
    <>
      {/* <div
        className={field.col ? "medium-" + field.col : "medium-3"}
        key={field._uid}
      >
        //{field.label ? <label htmlFor={field._uid}>{field.label}</label> : ""} //
        {(showSimplifiedOptions === true &&
          field.hasOwnProperty("simplifiedLabel") && (
            <label htmlFor={field._uid}>{field.simplifiedLabel}</label>
          )) || <label htmlFor={field._uid}>{field.label}</label>}
        <input
          type="checkbox"
          id={field._uid}
          name={field._uid}
          checked={value === field.value}
          value={value === field.value ? "" : field.value}
          onChange={(e) => {
            // Notify the main state list of the new value
            handleFieldChanged(field._uid, e.target.value, field.resetFields);
          }}
        />
      </div> */}

      <fieldSet
        class="-4 cell"
        className={field.col ? "large-" + field.col + " cell" : "large-3 cell"}
        key={field._uid}
      >
        <input
          type="checkbox"
          id={field._uid}
          name={field._uid}
          checked={value === field.value}
          value={value === field.value ? "" : field.value}
          onChange={(e) => {
            // Notify the main state list of the new value
            handleFieldChanged(field._uid, e.target.value, field.resetFields);
          }}
        />

        {(showSimplifiedOptions === true &&
          field.hasOwnProperty("simplifiedLabel") && (
            <label htmlFor={field._uid}>{field.simplifiedLabel}</label>
          )) || <label htmlFor={field._uid}>{field.label}</label>}
      </fieldSet>
    </>
  );
};

export default Checkbox;
